"use strict";
/**
 * Weekly Report V2 — Evaluation Context Types
 *
 * ECS produces safety warnings and treatment session grouping.
 * Product/treatment raw context lives in V2PreprocessedData.
 * Treatment response phases live on UserTreatmentData (computed by DataPreprocessingService).
 * ECS adds only what the LLM can't derive: rule-based guardrails + session grouping.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=evaluationContext.js.map